/**
 * Root reducer that combines all feature reducers into a single Redux state tree.
 *
 * @module rootReducer
 * @author Snowfly
 * @version 1.0.0
 */
import {combineReducers} from 'redux';
import simReducer from './sims/reducer';
import loginReducer from './authentication/reducer';
import adminReducer from './admin/reducer';
import settingsReducer from './settings/reducer';
import sfReducer from './sf/reducer';
import helpdeskReducer from './helpdesk/reducer';
import audioReducer from './audio/audioReducer';

export default combineReducers({
    sim: simReducer,
    login: loginReducer,
    admin: adminReducer,
    settings: settingsReducer,
    sf: sfReducer,
    helpdesk: helpdeskReducer,
    audio: audioReducer,
});
